export default {
  photoWallName: 'Image Wall',
  logoWallName: 'Logo Wall',
  brandWallName: 'Branding Wall',
  img: 'Image',
  logo: 'Logo',
  brandImg: 'Branding Image',
  view: 'View'
}
